import { render, staticRenderFns } from "./SettingsOptions.vue?vue&type=template&id=8b174714"
import script from "./SettingsOptions.vue?vue&type=script&lang=js"
export * from "./SettingsOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports